







import { Component, Mixins } from "vue-property-decorator";
import DeveloperAuthenticator from "./authentication/DeveloperAuthenticator.vue";
import DeveloperContents from "./DeveloperContents.vue";
import { WebStorageAccessor } from "../../store/WebStorageAccessor";

@Component({
  components: {
    DeveloperAuthenticator,
    DeveloperContents,
  }
})
export default class DeveloperView extends Mixins() {
  data() {
    return {
      isAuthenticated: WebStorageAccessor.isDeveloperMode,
    };
  }
  isAuthenticated: boolean;
}
